module.exports = __webpack_public_path__ + "img/1723019247940-WhatsApp Image 2024-08-07 at 16.14.46.jpeg.c42b81c9.webp";